import React, { useEffect, useState } from "react";

const DotLoader = ({ text = "Loading" }) => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 5); // Cycle from 0 to 3
    }, 500); // Adjust speed here

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ display: 'block', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000080', zIndex: 9999 }}>
      <div style={{
        position: 'absolute',
        top: 'calc(50% + 40px)',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#fff',
        fontSize: '16px',
        fontWeight: 'bold'
      }}>
        <div className="text-xl font-medium font-mono">
          {text}{".".repeat(dotCount)}
        </div>
      </div>
    </div>
  )

  // return (
  //   <div className="text-xl font-medium font-mono">
  //     {text}{".".repeat(dotCount)}
  //   </div>
  // );
};

export default DotLoader;